import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setSelectedArticle: (state: IRootState, action: PayloadAction<IRootState['selectedArticle']>) => ({
    ...state,
    selectedArticle: action.payload,
  }),
  setIsOpenFeedbackNav: (state: IRootState, action: PayloadAction<IRootState['isOpenFeedbackNav']>) => ({
    ...state,
    isOpenFeedbackNav: action.payload,
  }),
  setIsOpenDiscordNav: (state: IRootState, action: PayloadAction<IRootState['isOpenDiscordNav']>) => ({
    ...state,
    isOpenDiscordNav: action.payload,
  }),
  setSearchArticle: (state: IRootState, action: PayloadAction<IRootState['searchArticle']>) => ({
    ...state,
    searchArticle: action.payload,
  }),
};

export {
  reducers,
};
